import useHistoryTableFilterStore from 'src/stores/historyTableFilterStore/useHistoryTableFilterStore';
import { SelectOption } from 'src/components/primitives/Select/hooks/types';
import useSelect from 'src/components/primitives/Select/hooks/useSelect';
import Select from 'src/components/primitives/Select/Select';
import PortfolioHistoryTableControls from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableControls';
import PortfolioHistoryTableMarketFilter from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTableMarketFilter';
import { PortfolioHistoryTradesTableType } from 'src/components/PortfolioPage/PortfolioHistorySubPage/PortfolioHistoryTradesTable/types';

interface Props {
	tableType: PortfolioHistoryTradesTableType;
	setTableType: (tableType: PortfolioHistoryTradesTableType) => void;
}

const TABLE_TYPE_FILTER_OPTIONS: SelectOption<PortfolioHistoryTradesTableType>[] =
	[
		{ label: 'Perps & spot', value: 'perps-and-spot' },
		{ label: 'Swaps', value: 'swap' },
	];

export default function PortfolioHistoryTradesTableControls({
	tableType,
	setTableType,
}: Props) {
	const marketFilter = useHistoryTableFilterStore(
		(s) => s.getFilterState('trades')['marketSymbol']
	);
	const setHistoryTableFilterState = useHistoryTableFilterStore((s) => s.set);

	const handleMarketFilterChange = (selectedMarket: string) => {
		setHistoryTableFilterState((s) => {
			s.trades.marketSymbol = selectedMarket;
			s.trades.currentUiPage = 0;
		});
	};

	const {
		open,
		onOpenChange,
		value,
		onValueChange,
		selectOptions,
		selectedOption,
	} = useSelect({
		selectedValue: tableType,
		onSelectedValueChange: setTableType,
		options: TABLE_TYPE_FILTER_OPTIONS,
	});

	return (
		<PortfolioHistoryTableControls
			historyType={tableType === 'perps-and-spot' ? 'trades' : 'swaps'}
			exportType={tableType === 'perps-and-spot' ? 'trades' : 'swap-records'}
		>
			<Select.Root
				open={open}
				onOpenChange={onOpenChange}
				value={value}
				onValueChange={onValueChange}
			>
				<Select.Trigger label="Type" className="min-w-38">
					{selectedOption?.label}
				</Select.Trigger>
				<Select.Options>
					{selectOptions.map((option) => (
						<Select.Option key={option.value} value={option.value}>
							{option.label}
						</Select.Option>
					))}
				</Select.Options>
			</Select.Root>
			{tableType === 'perps-and-spot' && (
				<PortfolioHistoryTableMarketFilter
					marketFilter={marketFilter}
					handleMarketFilterChange={handleMarketFilterChange}
					id="portfolio-history-trades-table-market-filter"
				/>
			)}
		</PortfolioHistoryTableControls>
	);
}
